import { useTranslation } from 'react-i18next';
import type { DqsSourceStatus } from '../processes.api';

/**
 * Story 6.1 (FR15/FR16, UXR9, AD-19/AD-23) — de optionele, afschakelbare DQS-QA-
 * verrijkingsnaad. De MVP (OQ-4 uitgesteld) levert UITSLUITEND de gedegradeerde
 * "DQS-verrijking nu niet beschikbaar"-state: hetzelfde eersteklas, informatieve
 * (blauw, NOOIT rood/amber) degradatie-patroon als de rest van de module (zie
 * `ProcesDetail.tsx`/`StepTransitionTimingBlock.tsx`). Renders niets wanneer:
 * - de status ontbreekt (route droeg het veld niet), of
 * - de status `'ok'` is (gereserveerd voor de toekomstige activatiestory).
 */
export function DqsEnrichmentBlock({ status }: { status: DqsSourceStatus | undefined }) {
  const { t } = useTranslation();

  if (status == null || status === 'ok') return null;

  return (
    <p className="text-xs text-[var(--info-text)]" data-testid="process-detail-dqs-enrichment" role="status">
      {t('processes.dqs.notAvailable')}
    </p>
  );
}
